"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.manager = manager;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* eslint-disable no-param-reassign */
function isArray(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
}
function isUndefinedOrNotAnObject(obj) {
  return !obj || _typeof(obj) !== 'object' || isArray(obj);
}
function manager() {
  var answers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    getAnswer: function getAnswer(tableIndex, row, col) {
      if (!answers[tableIndex] || !answers[tableIndex][row] || !answers[tableIndex][row][col]) {
        return '';
      }
      return answers[tableIndex][row][col];
    },
    setAnswer: function setAnswer(tableIndex, row, col, text) {
      if (isUndefinedOrNotAnObject(answers[tableIndex])) {
        answers[tableIndex] = {};
      }
      if (isUndefinedOrNotAnObject(answers[tableIndex][row])) {
        answers[tableIndex][row] = {};
      }
      answers[tableIndex][row][col] = text;
      return answers;
    }
  };
}